var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      attrs: { active: "", "has-modal-card": "" },
      on: {
        close: function() {
          return _vm.$router.push({ name: "Customers" })
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-card",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.create($event)
            }
          }
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title has-text-primary" }, [
              _vm._v("\n        Conversación\n      ")
            ])
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _vm.loaded
                ? _c("IssoComments", {
                    staticClass: "box",
                    attrs: { loading: _vm.loading }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c(
                "RouterLink",
                { staticClass: "button", attrs: { to: { name: "Customers" } } },
                [_vm._v("\n        Cerrar\n      ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }